/** HubSpot "Wayflyer Insights" newsletter subscribe form (portal 6440909). */
export const NEWSLETTER_HUBSPOT_FORM_GUID =
  "d9f5ae50-3329-45c5-9d6c-439f70374516";
export const NEWSLETTER_FORM_NAME = "Wayflyer Insights newsletter";
